const LinkedInTrackingPixel = () => (
  <img
    height="1"
    width="1"
    style={{ display: 'none' }}
    alt=""
    src="https://px.ads.linkedin.com/collect/?pid=224172&conversionId=1030308&fmt=gif"
  />
)

export default LinkedInTrackingPixel
